import Playlist from './Playlists/Playlist';

function HomePage() {
  return (
    <div className="flex flex-col mt-16">
      <main className="h-full">
        <div className="space-y-4">
          <Playlist />
        </div>
      </main>
    </div>
  );
}

export default HomePage;
